// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PStepForwardOutlinedSvg from "@fishx/icons-svg/es/asn/PStepForwardOutlined";
import FishxIcon from '../components/FishxIcon';

var PStepForwardOutlined = function PStepForwardOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PStepForwardOutlinedSvg
  }));
};

PStepForwardOutlined.displayName = 'PStepForwardOutlined';
export default React.forwardRef(PStepForwardOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PStepForwardOutlined.js
// module id = 3660
// module chunks = 0